
import { createTranslations } from '../i18n/types';

export default createTranslations({
  en: {
    starting: 'Starting...',
    ended: 'Ended',
    noTime: 'No time',
    startPrice: 'Start',
    currentBid: 'Bid',
    startsIn: 'Starts in',
    statusLive: 'Live',
    statusSoon: 'Soon',
    statusEnded: 'Ended',
    bidsShort: 'bids',
  },
  ru: {
    starting: 'Начинается...',
    ended: 'Завершён',
    noTime: 'Нет времени',
    startPrice: 'Старт',
    currentBid: 'Ставка',
    startsIn: 'Через',
    statusLive: 'Идёт',
    statusSoon: 'Скоро',
    statusEnded: 'Завершён',
    bidsShort: 'ставок',
  },
  uz: {
    starting: 'Boshlanmoqda...',
    ended: 'Tugadi',
    noTime: "Vaqt yo'q",
    startPrice: 'Boshlash',
    currentBid: 'Taklif',
    startsIn: 'Keyin',
    statusLive: 'Jonli',
    statusSoon: 'Tez orada',
    statusEnded: 'Tugadi',
    bidsShort: 'taklif',
  },
});
